var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermisosRol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_66_7",
    "data-name": "Componente 66 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.001,
    viewBox: "0 0 32 32.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    transform: "translate(0 0.001)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock_person_FILL0_wght300_GRAD0_opsz40",
    d: "M201.178-855.75a2.362,2.362,0,0,0,1.737-.715,2.364,2.364,0,0,0,.714-1.735,2.331,2.331,0,0,0-.714-1.725,2.377,2.377,0,0,0-1.734-.7,2.339,2.339,0,0,0-1.726.711,2.361,2.361,0,0,0-.706,1.727,2.36,2.36,0,0,0,.709,1.729A2.337,2.337,0,0,0,201.178-855.75Zm0,4.88a4.726,4.726,0,0,0,2.277-.569,4.89,4.89,0,0,0,1.739-1.567,9.011,9.011,0,0,0-1.946-.833,7.31,7.31,0,0,0-2.064-.293,7.384,7.384,0,0,0-2.071.293,8.756,8.756,0,0,0-1.943.833,4.778,4.778,0,0,0,1.728,1.567,4.737,4.737,0,0,0,2.279.569Zm-14.411-18.971h9.645v-3.339a4.726,4.726,0,0,0-1.4-3.467,4.641,4.641,0,0,0-3.421-1.409,4.641,4.641,0,0,0-3.421,1.409,4.726,4.726,0,0,0-1.4,3.467Zm6.8,19.967H182.417a2.322,2.322,0,0,1-1.7-.717,2.322,2.322,0,0,1-.717-1.7v-15.135a2.322,2.322,0,0,1,.717-1.7,2.322,2.322,0,0,1,1.7-.717h2.406v-3.335a6.612,6.612,0,0,1,1.964-4.842,6.5,6.5,0,0,1,4.8-1.979,6.5,6.5,0,0,1,4.8,1.979,6.612,6.612,0,0,1,1.964,4.842v3.335h2.406a2.322,2.322,0,0,1,1.7.717,2.322,2.322,0,0,1,.717,1.7v2.573a6.363,6.363,0,0,0-.881-.159,9.413,9.413,0,0,0-1.06-.054v-2.359a.463.463,0,0,0-.134-.342.463.463,0,0,0-.342-.134H182.417a.463.463,0,0,0-.342.134.463.463,0,0,0-.134.342v15.135a.463.463,0,0,0,.134.342.463.463,0,0,0,.342.134H192.46a6.473,6.473,0,0,0,.444,1A6.213,6.213,0,0,0,193.559-849.874Zm7.621,1.133a6.57,6.57,0,0,1-4.82-2,6.565,6.565,0,0,1-2-4.816,6.581,6.581,0,0,1,2-4.82,6.562,6.562,0,0,1,4.82-2.005,6.563,6.563,0,0,1,4.82,2,6.575,6.575,0,0,1,2,4.816,6.57,6.57,0,0,1-2,4.82A6.57,6.57,0,0,1,201.18-848.741Zm-19.238-14.7v0Z",
    transform: "translate(-178.004 879.997)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermisosRol);
export default __webpack_public_path__ + "static/media/permisos-rol.b1e840189519a5e28c7ea9ce24731c5d.svg";
export { ForwardRef as ReactComponent };